import Component from '../core/Component';
import Ajax from '../core/Ajax';
import debounce from 'lodash/debounce';

export default class Search extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            searchInput:       null,
            searchInputEraser: null,
            searchSuggestions: null,
            searchSubmit:      null,
            expandSearch:      null, // expandable search input in blog
        };
        this.expandable = {
            expandedClass: 'is-expanded',
            expanded:      false,
        };
    }

    prepare() {
        this.ref.searchInput.value.length > 0 ? this.eraserShow(true) : null;
        this.ref.searchInput.addEventListener('keyup', this.inputLogic.bind(this));
        this.ref.searchInput.addEventListener('keydown', (event) => this.keyEvents(event.keyCode));
        this.ref.searchInput.addEventListener('blur', this.inputBlur.bind(this));
        this.ref.searchInputEraser.addEventListener('click', this.clearSearchInput.bind(this));
        if (this.ref.searchSubmit !== null) this.ref.searchSubmit.addEventListener('click', this.submit.bind(this));

        if (this.ref.expandSearch) {
            this.eraserShow(true);
            this.ref.expandSearch.addEventListener('click', this.expandSearchbar.bind(this));
        }
    }

    keyEvents(keyCode) {
        switch (keyCode) {
            // esc
            case 27:
                if (this.ref.searchInput) {
                    this.expandSearchbar();
                }
                break;
            // del
            case 46:
                this.clearSearchInput();
                break;
        }
    }

    debounceSearch = debounce(() => {
        if (!this.ref.searchSuggestions || !this.ref.searchSuggestions.dataset.url) {
            return;
        }

        let url = this.ref.searchSuggestions.dataset.url;
        let value = this.ref.searchInput.value;

        if (value.length > 0) {
            let ajax = new Ajax();
            let self = this;
            url = url.replace('__QUERY__', value);

            ajax.post(url, {}, function (payload) {
				let jsonPayload = JSON.parse(payload);

				if (jsonPayload.length !== 0) {
					self.clearSuggestions();
					self.prepareSuggestionsItems(jsonPayload);
				} else {
					self.suggestionsShow(false);
				}
            });
        }
    }, 500);

    inputLogic() {
        if (this.ref.expandSearch) return;

        if (this.ref.searchInput.value.length > 0) {
            this.eraserShow(true);
            this.suggestionsShow(true);
            // this.search();
            this.debounceSearch();
        } else {
            this.eraserShow(false);
            this.suggestionsShow(false);
        }
    }

    search() {
        // Old version without debounce

        if (!this.ref.searchSuggestions || !this.ref.searchSuggestions.dataset.url) {
            return;
        }

        let url = this.ref.searchSuggestions.dataset.url;
        let value = this.ref.searchInput.value;

        if (value.length > 0) {
            let ajax = new Ajax();
            let self = this;
            url = url.replace('__QUERY__', value);

            ajax.post(url, {}, function (payload) {
                let jsonPayload = JSON.parse(payload);

                self.clearSuggestions();
                self.prepareSuggestionsItems(jsonPayload);
            });
        }
    }

    stripHtml(html) {
        let doc = new DOMParser().parseFromString(html, 'text/html');

        doc.body.querySelectorAll('.wp-caption').forEach(e => e.remove());

        let result = doc.body.textContent || '';

        return result.replace(/(\r\n|\r|\n)/g, '');
    }

    clearSuggestions() {
        document.querySelectorAll('.suggestions__item').forEach(e => e.remove());
    }

    prepareSuggestionsItems(payload) {
        let self = this;
        let suggestionsEl = this.ref.searchSuggestions.getElementsByClassName('suggestions');

        payload.forEach(function (item) {
            let itemElement = self.createSearchItem(
                item.url,
                item.title,
                item.category
            );
            // self.stripHtml(item.description)

            suggestionsEl[0].appendChild(itemElement);
        });
    }

    createSearchItem(url, title, category) {
        let suggestionItem = document.createElement('div');
        let itemHref = document.createElement('a');
        let itemTitle = document.createElement('span');
        let itemCategory = document.createElement('span');

        // itemTitle.classList.add('suggestions__item-title');
        itemTitle.innerText = title;

        // itemCategory.classList.add('suggestions__item-title');
        itemCategory.innerText = category;

        itemHref.classList.add('dsuggestions__item-search');
        itemHref.setAttribute('href', url);
        itemHref.append(itemTitle);
        itemHref.append(itemCategory);

        suggestionItem.classList.add('suggestions__item');
        suggestionItem.append(itemHref);

        return suggestionItem;
    }

    // createSearchItem(url, title, description) {
    //     let suggestionItem = document.createElement('div');
    //     let itemHref = document.createElement('a');
    //     let itemTitle = document.createElement('span');
    //     let itemDesc = document.createElement('p');
    //
    //     itemTitle.classList.add('suggestions__item-title');
    //     itemTitle.innerText = title;
    //
    //     itemDesc.classList.add('suggestions__item-text');
    //     itemDesc.innerText = description.substring(0, 100);
    //
    //     itemHref.classList.add('suggestions__item-search');
    //     itemHref.setAttribute('href', url);
    //     itemHref.append(itemTitle);
    //     itemHref.append(itemDesc);
    //
    //     suggestionItem.classList.add('suggestions__item');
    //     suggestionItem.append(itemHref);
    //
    //     return suggestionItem;
    // }

    inputBlur() {
        if (this.ref.searchSuggestions) {
            let self = this;

            setTimeout(function () {
                self.suggestionsShow(false);
            }, 300);
        }
    }

    inputFocus() {
        this.ref.searchInput.focus();
    }

    eraserShow(state) {
        if (state) {
            this.ref.searchInputEraser.classList.add('visible');
        } else {
            this.ref.searchInputEraser.classList.remove('visible');
        }
    }

    clearSearchInput() {
        this.ref.searchInput.value = '';
        if (this.ref.expandSearch) {
            this.expandSearchbar();
            return;
        }
        this.eraserShow(false);
    }

    suggestionsShow(state) {
        if (this.ref.searchSuggestions === null) return;
        if (this.ref.searchSuggestions.querySelector('.suggestions').children.length > 0) {
            if (state) {
                this.ref.searchSuggestions.classList.add('show');
            } else {
                this.ref.searchSuggestions.classList.remove('show');
            }
        }
    }

    expandSearchbar() {
        if (!this.element.classList.contains(this.expandable.expandedClass)) {
            setTimeout(() => {
                this.inputFocus();
            }, 50);
        }
        this.element.classList.toggle(this.expandable.expandedClass);
    }

    submit() {
        // submit action prepare
        // reset input
        // this.ref.searchInput.value = "";
        if (this.ref.expandSearch) {
            this.expandSearchbar();
            this.eraserShow(true);
        }
    }
}
